import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { Button, ButtonVariantType, JabraIcon } from '@gn-audio/jss-components';

export type GenericBentoGridButtonProps = {
  id?: string;
  variant: Field<ButtonVariantType>;
  icon: Field<keyof typeof icons>;
  label: Field<string>;
  link: LinkField;
};

const GenericBentoGridButtonComponent = ({
  variant,
  icon,
  label,
  link,
}: GenericBentoGridButtonProps) => {
  return (
    <div className="pb-3">
      <Button
        variant={variant?.value || 'primary'}
        size={!!label?.value ? 'm' : 'l'}
        asLink
        href={link?.value.href}
        iconPlacement={!!icon?.value ? 'right' : undefined}
        aria-label={!!label?.value ? '' : link?.value.href}
        icon={
          !!icon?.value && (
            <JabraIcon
              Icon={icons?.[icon.value]}
              {...(!label?.value && {
                className: 'w-10 h-10',
                iconStyle: { height: 40, width: 40 },
              })}
            />
          )
        }
      >
        {label?.value}
      </Button>
    </div>
  );
};

export default GenericBentoGridButtonComponent;
